// eslint-disable-next-line
import { UserLayout, BasicLayout, RouteView, BlankLayout, PageView, iframe } from '@/layouts'
import { bxAnaalyse } from '@/core/icons'

/**
 * 菜单所需要的字段
 * @type {*[]}
 * path
 * meta : {
 *   title: '首页',
 *   keepAlive: true,
 *   icon: bxAnaalyse
 * }
 * hidden: 可以在菜单中不展示这个路由，包括子路由
 * hideChildrenInMenu: 隐藏不需要在菜单中展示的子路由
 * children: [
 *
 * ]
 *
 */
export const asyncRouterMap = [

  {
    path: '/',
    name: 'index',
    component: BasicLayout,
    meta: { title: '首页' },
    redirect: '/dashboard',
    children: [
      {
        path: '/dashboard',
        name: 'dashboard',
        redirect: '/dashboard/analysis',
        component: RouteView,
        meta: { title: '首页', keepAlive: true, icon: bxAnaalyse, permission: [ 'dashboard' ] },
        children: [
          {
            path: '/dashboard/analysis',
            name: 'Analysis',
            component: () => import('@/views/dashboard/Analysis'),
            meta: { title: '工作台', keepAlive: false, permission: [ 'dashboard:analysis' ] }
          },
          {
            path: '/warning',
            name: 'warning',
            hidden: true,
            component: () => import('@/views/modules/sx/warning/warning'),
            meta: { title: '预警信息', keepAlive: false, permission: [ 'dashboard:analysis' ] }
          }
        ]
      },
      {
        path: '/sx/notice',
        name: 'notice',
        component: PageView,
        meta: { title: '通知公告', keepAlive: true, icon: 'form', permission: [ 'notice' ] },
        children: [
          {
            path: '/notice/noticeView',
            name: 'noticeView',
            component: () => import('@/views/modules/sx/notice/noticeView'),
            meta: { title: '通知管理', permission: [ 'notice:noticeView' ] }
          },
          {
            path: '/notice/noticeAddOrUpdate',
            name: 'noticeAddOrUpdate',
            hidden: true,
            component: () => import('@/views/modules/sx/notice/noticeAddOrUpdate'),
            meta: { title: '通知发布' }
          },
          {
            path: '/notice/noticeDetails',
            name: 'noticeDetails',
            hidden: true,
            component: () => import('@/views/modules/sx/notice/noticeDetails'),
            meta: { title: '通知详情' }
          }
        ]
      },
      {
        path: '/sx/project',
        name: 'build',
        component: PageView,
        hidden: true,
        meta: { title: '工程信息', keepAlive: true, icon: 'setting', permission: [ 'build' ] },
        children: [
        ]
      },
      {
        path: '/sx/project',
        name: 'curing',
        component: PageView,
        hidden: true,
        meta: { title: '养护信息', keepAlive: true, icon: 'setting', permission: [ 'curing' ] },
        children: [
          // {
          //   path: '/sx/project/curinginfo',
          //   name: 'projectCuringInfo',
          //   component: () => import('@/views/modules/sx/project/curinginfo/ProjectCuringInfoView'),
          //   meta: { title: '信息管理', permission: [ 'curing:projectCuringInfo' ] }
          // },
          // {
          //   path: '/sx/project/curingInfoAdd',
          //   name: 'ProjectCuringInfoAdd',
          //   component: () => import('@/views/modules/sx/project/curinginfo/ProjectCuringInfoAddOrUpdate'),
          //   meta: { title: '新增养护', permission: [ 'curing:projectCuringInfoAdd' ] }
          // },
          // {
          //   path: '/sx/project/curingInfoUpdate/:curingId/:type',
          //   name: 'ProjectCuringInfoUpdate',
          //   hidden: true,
          //   component: () => import('@/views/modules/sx/project/curinginfo/ProjectCuringInfoAddOrUpdate'),
          //   meta: { title: '修改养护' }
          // },
          // {
          //   path: '/sx/project/curingInfoShow/:curingId/:type',
          //   name: 'ProjectCuringInfoShow',
          //   hidden: true,
          //   component: () => import('@/views/modules/sx/project/curinginfo/ProjectCuringInfoAddOrUpdate'),
          //   meta: { title: '查看养护' }
          // }
        ]
      },
      {
        meta: { title: '施工工程', icon: 'form', permission: ['dailyBuild'] },
        component: PageView,
        path: '/dailyBuild',
        name: 'dailyBuild',
        children: [
          {
            path: '/sx/project/buildInfo',
            name: 'projectBuildInfo',
            component: () => import('@/views/modules/sx/project/buildinfo/ProjectBuildInfoView'),
            meta: { title: '信息管理', permission: [ 'build:projectBuildInfo' ] }
          },
          {
            path: '/sx/project/buildInfoUpdate',
            name: 'ProjectBuildInfoUpdate',
            hidden: true,
            component: () => import('@/views/modules/sx/project/buildinfo/buildInfoAddOrUpdate'),
            meta: { title: '修改工程' }
          },
          {
            path: '/sx/project/buildInfoShow',
            name: 'ProjectBuildInfoShow',
            hidden: true,
            component: () => import('@/views/modules/sx/project/buildinfo/buildInfoAddOrUpdate'),
            meta: { title: '查看工程' }
          },
          {
            path: '/dailyBuild/dailyBuildView',
            name: 'dailyBuildView',
            meta: { title: '施工日报', keepAlive: true, permission: ['dailyBuild:dailyBuildView'] },
            component: () => import('@/views/modules/sx/daily/dailyBuild/dailyBuildView')
          },
          {
            path: '/dailyBuild/buildSubcontract',
            name: 'buildSubcontract',
            meta: { title: '分包及分摊', permission: ['dailyBuild:buildSubcontract'] },
            component: () => import('@/views/modules/sx/daily/dailyBuild/buildSubcontract')
          },
          {
            path: '/dailyBuild/collect',
            name: 'dailyBuildCollect',
            meta: { title: '日报信息汇总', permission: ['dailyBuild:dailyBuildCollect'] },
            component: () => import('@/views/modules/sx/daily/dailyBuild/dailyBuildCost')
          },
          {
            path: '/dailyBuild/dailyBuildAdd',
            name: 'dailyBuildAdd',
            hidden: true,
            meta: { title: '施工日报表单', keepAlive: true },
            component: () => import('@/views/modules/sx/daily/dailyBuild/dailyBuildAdd')
          }
        ]
      },
      {
        meta: { title: '养护路段', icon: 'form', permission: ['dailyCuring'] },
        component: PageView,
        path: '/dailyCuring',
        name: 'dailyCuring',
        children: [
          {
            path: '/sx/project/curinginfo',
            name: 'projectCuringInfo',
            component: () => import('@/views/modules/sx/project/curinginfo/ProjectCuringInfoView'),
            meta: { title: '信息管理', permission: [ 'curing:projectCuringInfo' ] }
          },
          {
            path: '/sx/project/curingInfoUpdate',
            name: 'ProjectCuringInfoUpdate',
            hidden: true,
            component: () => import('@/views/modules/sx/project/curinginfo/ProjectCuringInfoAddOrUpdate'),
            meta: { title: '修改养护' }
          },
          {
            path: '/sx/project/curingInfoShow',
            name: 'ProjectCuringInfoShow',
            hidden: true,
            component: () => import('@/views/modules/sx/project/curinginfo/ProjectCuringInfoAddOrUpdate'),
            meta: { title: '查看养护' }
          },
          {
            path: '/dailyCuring/dailyCuringView',
            name: 'dailyCuringView',
            meta: { title: '养护日报', permission: ['dailyCuring:dailyCuringView'] },
            component: () => import('@/views/modules/sx/daily/dailyCuring/dailyCuringView')
          },
          {
            path: '/dailyCuring/curingSubcontract',
            name: 'curingSubcontract',
            meta: { title: '分包及分摊', permission: ['dailyCuring:curingSubcontract'] },
            component: () => import('@/views/modules/sx/daily/dailyCuring/curingSubcontract')
          },
          {
            path: '/dailyCuring/collect',
            name: 'dailyCuringCollect',
            meta: { title: '日报信息汇总', permission: ['dailyBuild:dailyCuringCollect'] },
            component: () => import('@/views/modules/sx/daily/dailyCuring/dailyCuringCost')
          },
          {
            path: '/dailyBuild/dailyCuringAdd',
            name: 'dailyCuringAdd',
            hidden: true,
            meta: { title: '养护日报表单', keepAlive: false },
            component: () => import('@/views/modules/sx/daily/dailyCuring/dailyCuringAdd')
          }
        ]
      },
      {
        meta: { title: '考勤管理', icon: 'form', permission: ['attend'] },
        component: PageView,
        path: '/attend',
        name: 'attend',
        children: [
          {
            path: '/attend/worker',
            name: 'worker-form',
            meta: { title: '人员增/减', permission: ['attend:worker-form'] },
            component: () => import('@/views/modules/sx/attend/worker/AttendWorkerView')
          },
          {
            path: '/attend/editDaily',
            name: 'editDaily',
            meta: { title: '考勤填报', permission: ['attend:editDaily'] },
            component: () => import('@/views/modules/sx/attend/daily/NewEditDaily')
          },
          {
            path: '/attend/showDaily',
            name: 'showDaily',
            meta: { title: '查看/导出', permission: ['attend:showDaily'] },
            component: () => import('@/views/modules/sx/attend/daily/ShowDaily')
          }
        ]
      },
      {
        path: '/sx/correctError',
        name: 'correctError',
        component: PageView,
        meta: { title: '管理纠偏', keepAlive: true, icon: 'form', permission: [ 'correctError' ] },
        children: [
          {
            path: '/correctError/CorrectErrorView',
            name: 'CorrectErrorView',
            component: () => import('@/views/modules/sx/correctError/CorrectErrorView'),
            meta: { title: '问题处理', permission: [ 'correctError:correctErrorView' ] }
          },
          {
            path: '/correctError/CorrectErrorAddOrUpdate',
            name: 'CorrectErrorAddOrUpdate',
            hidden: true,
            component: () => import('@/views/modules/sx/correctError/CorrectErrorAddOrUpdate'),
            meta: { title: '问题发起' }
          },
          {
            path: '/correctError/CorrectErrorDetails',
            name: 'CorrectErrorDetails',
            hidden: true,
            component: () => import('@/views/modules/sx/correctError/CorrectErrorDetails'),
            meta: { title: '问题详情' }
          }
        ]
      },
      {
        path: '/sx/repository',
        name: 'repository',
        component: PageView,
        meta: { title: '知识库', keepAlive: true, icon: 'form', permission: [ 'repository' ] },
        children: [
          {
            path: '/repository/repositoryView',
            name: 'repositoryView',
            component: () => import('@/views/modules/sx/repository/repositoryView'),
            meta: { title: '知识查看', permission: [ 'repository:repositoryView' ] }
          },
          {
            path: '/repository/repositoryAddOrUpdate',
            name: 'repositoryAddOrUpdate',
            hidden: true,
            component: () => import('@/views/modules/sx/repository/repositoryAddOrUpdate'),
            meta: { title: '知识发布' }
          },
          {
            path: '/repository/repositoryDetails',
            name: 'repositoryDetails',
            hidden: true,
            component: () => import('@/views/modules/sx/repository/repositoryDetails'),
            meta: { title: '知识详情' }
          }
        ]
      },
      {
        meta: { title: '文件柜', icon: 'form', permission: [ 'sys:file' ] },
        component: PageView,
        path: '/file',
        name: 'file',
        children: [
          {
            path: '/sys/file',
            name: 'file',
            component: () => import('@/views/modules/sys/file/FileView'),
            meta: { title: '文件管理', keepAlive: true, permission: [ 'sys:file' ] }
          },
          {
            path: '/sys/fileAddOrUpdate',
            name: 'fileAddOrUpdate',
            hidden: true,
            component: () => import('@/views/modules/sys/file/FileAddOrUpdate'),
            meta: { title: '文件添加', keepAlive: true }
          }
        ]
      },
      {
        meta: { title: '采购管理', icon: 'form', permission: ['purchase'] },
        component: PageView,
        path: '/purchase',
        name: 'purchase',
        children: [
          {
            path: '/purchase/supplier',
            name: 'supplier-form',
            meta: { title: '供货商', permission: ['purchase:supplier-form'] },
            component: () => import('@/views/modules/sx/purchase/supplier/SxSupplierView')
          },
          {
            path: '/purchase/purchaseInfo',
            name: 'purchaseInfo',
            meta: { title: '采购信息确认', permission: ['purchase:purchaseInfo'] },
            component: () => import('@/views/modules/sx/purchase/purchaseInfo/PurchaseInfo')
          },
          {
            path: '/purchase/assets',
            name: 'assets-form',
            hidden: true,
            meta: { title: '固定资产管理', permission: ['purchase:assets-form'] },
            component: () => import('@/views/modules/sx/purchase/assets/SxAssetView')
          },
          {
            path: '/purchase/machine',
            name: 'machine-form',
            hidden: true,
            meta: { title: '公司机械管理', permission: ['purchase:machine-form'] },
            component: () => import('@/views/modules/sx/purchase/machine/SxCompanyMachineView')
          },
          {
            path: '/purchase/material',
            name: 'material-form',
            hidden: true,
            meta: { title: '主材管理' },
            component: () => import('@/views/modules/sx/purchase/material/SxMaterialView')
          },
          {
            path: '/purchase/trees',
            name: 'tree-form',
            meta: { title: '市场价格', permission: ['purchase:price'] },
            component: () => import('@/views/modules/sx/purchase/trees/SxTreeView')
          }
        ]
      },
      {
        meta: { title: '机械/固定资产', icon: 'form', permission: ['mechanicalAndAssets'] },
        component: PageView,
        path: '/mechanicalAndAssets',
        name: 'mechanicalAndAssets',
        children: [
          {
            path: '/mechanicalAndAssets/machine',
            name: 'companyMachine',
            meta: { title: '公司机械', permission: ['purchase:machine-form'] },
            component: () => import('@/views/modules/sx/purchase/machine/SxCompanyMachineView')
          },
          {
            path: '/mechanicalAndAssets/assets',
            name: 'Assets',
            meta: { title: '固定资产', permission: ['purchase:assets-form'] },
            component: () => import('@/views/modules/sx/purchase/assets/SxAssetView')
          }
        ]
      },
      {
        meta: { title: '结算确认', icon: 'form', permission: ['verification'] },
        component: PageView,
        path: '/verification',
        name: 'verification',
        children: [
          {
            path: '/verification/hireWorkerCost',
            name: 'hireWorkerCostVerification',
            component: () => import('@/views/modules/sx/verification/hireWorkerCost/hireWorkerCost'),
            meta: { title: '外雇人工', permission: ['hireWorkerCostVerification'] }
          },
          {
            path: '/verification/outMachineCost',
            name: 'outMachineCostVerification',
            component: () => import('@/views/modules/sx/verification/outMachineCost/outMachineCost'),
            meta: { title: '外雇机械', permission: ['companyMechanicalCostVerification'] }
          },
          {
            path: '/verification/seedlingCost',
            name: 'seedlingCostVerification',
            component: () => import('@/views/modules/sx/verification/seedlingCost/seedingCost.vue'),
            meta: { title: '苗木成本', permission: ['seedlingCostVerification'] }
          },
          {
            path: '/verification/materialCost',
            name: 'materialCostVerification',
            component: () => import('@/views/modules/sx/verification/materialCost/materialCost'),
            meta: { title: '材料成本', permission: ['materialCostVerification'] }
          },
          {
            path: '/verification/fixedAssetsCost',
            name: 'fixedAssetsCostVerification',
            component: () => import('@/views/modules/sx/verification/fixedAssetsCost/fixedAssetsCost.vue'),
            meta: { title: '固定资产', permission: ['fixedAssetsCostVerification'] }
          },
          {
            path: '/verification/otherCost',
            name: 'otherCostVerification',
            component: () => import('@/views/modules/sx/verification/otherCost/otherCost'),
            meta: { title: '现金支付', permission: ['otherCostVerification'] }
          }
        ]
      },
      {
        path: '/sx/statement',
        name: 'statement',
        component: PageView,
        meta: { title: '成本分析', keepAlive: true, icon: 'form', permission: ['statement'] },
        children: [
          {
            path: '/statement/workerCost',
            name: 'workerCost',
            component: () => import('@/views/modules/sx/statement/workerCost/workerCost'),
            meta: { title: '1.公司工人' }
          },
          {
            path: '/statement/hireWorkerCost',
            name: 'hireWorkerCost',
            component: () => import('@/views/modules/sx/statement/hireWorkerCost/hireWorkerCost'),
            meta: { title: '2.外雇工人' }
          },
          {
            path: '/statement/outMachineCost',
            name: 'outMachineCost',
            component: () => import('@/views/modules/sx/statement/outMachineCost/outMachineCost'),
            meta: { title: '3.外雇机械' }
          },
          {
            path: '/statement/seedlingCost',
            name: 'seedlingCost',
            component: () => import('@/views/modules/sx/statement/seedlingCost/seedingCost.vue'),
            meta: { title: '4.苗木成本' }
          },
          {
            path: '/statement/materialCost',
            name: 'materialCost',
            component: () => import('@/views/modules/sx/statement/materialCost/materialCost'),
            meta: { title: '5.材料成本' }
          },
          {
            path: '/statement/fixedAssetsCost',
            name: 'fixedAssetsCost',
            component: () => import('@/views/modules/sx/statement/fixedAssetsCost/fixedAssetsCost.vue'),
            meta: { title: '6.固定资产' }
          },
          {
            path: '/statement/otherCost',
            name: 'otherCost',
            component: () => import('@/views/modules/sx/statement/otherCost/otherCost'),
            meta: { title: '7.现金支付' }
          },
          {
            path: '/statement/subContractCost',
            name: 'subContractCost',
            component: () => import('@/views/modules/sx/statement/subContractCost/subContractCost'),
            meta: { title: '8.分包及费用分摊' }
          },
          {
            path: '/statement/companyMechanicalCost',
            name: 'companyMechanicalCost',
            component: () => import('@/views/modules/sx/statement/companyMechanicalCost/companyMechanicalCost'),
            meta: { title: '9.公司机械' }
          },
          {
            path: '/statement/projectCost',
            name: 'projectCost',
            component: () => import('@/views/modules/sx/statement/projectCost/projectCost'),
            meta: { title: '项目成本汇总' }
          }
        ]
      },
      {
        path: '/sys',
        name: 'sys',
        component: PageView,
        meta: { title: '系统管理', keepAlive: true, permission: [ 'sys' ], icon: 'setting' },
        children: [
          {
            path: '/sx/project/buildInfoAdd',
            name: 'buildInfoAdd',
            component: () => import('@/views/modules/sx/project/buildinfo/buildInfoAdd'),
            meta: { title: '新增施工工程', permission: [ 'build:projectBuildInfoAdd' ] }
          },
          {
            path: '/sx/project/curingInfoAdd',
            name: 'ProjectCuringInfoAdd',
            component: () => import('@/views/modules/sx/project/curinginfo/ProjectCuringInfoAdd'),
            meta: { title: '新增养护路段', permission: [ 'curing:projectCuringInfoAdd' ] }
          },
          {
            path: '/common/prostaff',
            name: 'prostaff',
            meta: { title: '项目人员关联', permission: ['sys:common:prostaff'] },
            component: () => import('@/views/modules/sx/common/prostaff/ProjectStaffView')
          },
          {
            path: '/upms/user',
            name: 'user',
            component: () => import('@/views/modules/sys/user/user'),
            meta: { title: '用户管理', keepAlive: true, permission: ['admin:user'] }
          },
          {
            path: '/attend/group',
            name: 'group-form',
            meta: { title: '项目考勤小组增减', permission: ['sys:attend:group-form'] },
            component: () => import('@/views/modules/sx/attend/group/AttendGroupView')
          },
          {
            path: '/attend/company',
            name: 'company-form',
            meta: { title: '公司考勤小组增减', permission: ['sys:attend:company-form'] },
            component: () => import('@/views/modules/sx/attend/company/AttendCompanyView')
          },
          {
            path: '/common/workType',
            name: 'workType',
            meta: { title: '工人类别', permission: ['sys:common:workType'] },
            component: () => import('@/views/modules/sx/common/workType/WorkerTypeView')
          },
          {
            path: '/sys/dict',
            name: 'dict',
            component: () => import('@/views/modules/sys/dict/dict'),
            meta: { title: '数据字典', keepAlive: true, permission: ['sys:dict'] }
          },
          {
            path: '/sys/client',
            name: 'client',
            component: () => import('@/views/modules/sys/client/client'),
            meta: { title: '终端管理', keepAlive: true, permission: ['sys:client'] }
          },
          {
            path: '/sys/log',
            name: 'log',
            component: () => import('@/views/modules/sys/log'),
            meta: { title: '日志管理', keepAlive: true, permission: ['sys:log'] }
          },
          {
            path: '/sys/token',
            name: 'token',
            component: () => import('@/views/modules/sys/token'),
            meta: { title: '令牌管理', keepAlive: true, permission: ['sys:token'] }
          }
        ]
      },
      {
        path: '/upms',
        name: 'upms',
        component: PageView,
        meta: { title: '权限管理', keepAlive: true, permission: ['admin'], icon: 'safety-certificate' },
        children: [
          {
            path: '/upms/menu',
            name: 'menu',
            component: () => import('@/views/modules/sys/menu/menu'),
            meta: { title: '权限管理(勿动)', keepAlive: true, permission: ['admin:permission'] }
          },
          {
            path: '/upms/role',
            name: 'role',
            component: () => import('@/views/modules/sys/role/role'),
            meta: { title: '角色管理(勿动)', keepAlive: true, permission: ['admin:role'] }
          },
          {
            path: '/upms/dept',
            name: 'dept',
            component: () => import('@/views/modules/sys/dept/dept'),
            meta: { title: '部门管理', keepAlive: true, permission: ['admin:dept'] }
          },
          {
            path: '/upms/deptUserlist',
            name: 'deptUserlist',
            component: () => import('@/views/modules/sys/deptUserList'),
            meta: { title: '我的部门', keepAlive: true, permission: ['admin:my:dept'] }
          }
        ]
      },
      {
        meta: { title: '系统监控', icon: 'fund', permission: ['visual'] },
        component: BlankLayout,
        path: '/visual',
        name: 'visual',
        children: [
          {
            path: '/myiframe/urlPath',
            query: 'http://139.159.231.161/swagger-ui.html',
            name: 'swagger',
            meta: { title: '接口文档' },
            component: iframe
          },
          {
            path: '/myiframe/urlPath',
            query: 'http://139.159.231.161:8090',
            name: 'job',
            meta: { title: '定时任务' },
            component: iframe
          }
        ]
      },
      // account
      {
        path: '/account',
        component: RouteView,
        redirect: '/account/center',
        name: 'account',
        hideChildrenInMenu: true,
        hidden: true,
        meta: { title: '个人页', icon: 'user', keepAlive: true },
        children: [
          {
            path: '/account/settings',
            name: 'settings',
            component: () => import('@/views/account/settings/Index'),
            meta: { title: '个人设置', hideHeader: true },
            redirect: '/account/settings/base',
            children: [
              {
                path: '/account/settings/base',
                name: 'BaseSettings',
                component: () => import('@/views/account/settings/BaseSetting'),
                meta: { title: '基本设置', hidden: true }
              },
              {
                path: '/account/settings/custom',
                name: 'CustomSettings',
                component: () => import('@/views/account/settings/Custom'),
                meta: { title: '个性化设置', hidden: true, keepAlive: true }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    path: '*', redirect: '/404', hidden: true
  }
]

/**
 * 基础路由
 * @type { *[] }
 */
export const constantRouterMap = [
  {
    path: '/user',
    component: UserLayout,
    redirect: '/user/login',
    hidden: true,
    children: [
      {
        path: 'login',
        name: 'login',
        component: () => import(/* webpackChunkName: "user" */ '@/page/login')
      }
    ]
  },
  {
    path: '/test',
    name: 'test',
    component: () => import('@/views/Home')
  },
  {
    path: '/404',
    component: () => import(/* webpackChunkName: "fail" */ '@/views/exception/404')
  }

]
